import UnstableDataFragment from './UnstableDataFragment'

export default `
  mutation SetUnstableData($input: SetUnstableDataInput!) {
    setUnstableData(input: $input) {
      ...UnstableDataFragment
    }
  } 
  ${UnstableDataFragment}
`
